module.exports = __webpack_public_path__ + "img/vase-small.36ca9de0.svg";